// Sleduje, ktery hrac naposledy sam vyvolal mutaci na PvP zapase (challenge/accept/decline/choose-pokemon/choose-skill), aby prichozi Mercure pvp_update (chodi VZDY oboum hracum, viz PvpService::notify()) sel rozlisit na "zpusobil jsem to ja" vs. "udelal to souper".
// V pameti, ne Vuex - kratkodoby priznak s TTL, ne reaktivni stav; TTL chrani pred zustanutim navzdy pri vypadku push notifikace.
const SELF_ACTION_TTL_MS = 8000;
const selfActionAt = new Map();

export function markPvpSelfAction(matchId) {
    if (matchId === null || matchId === undefined) {
        return;
    }
    selfActionAt.set(String(matchId), Date.now());
}

// Vraci true prave jednou za akci (konzumuje zaznam) - dalsi push na stejny matchId uz spravne vyhodnoti jako "ne moje akce".
export function consumePvpSelfAction(matchId) {
    const key = String(matchId);
    const at = selfActionAt.get(key);
    if (at === undefined) {
        return false;
    }
    selfActionAt.delete(key);
    return (Date.now() - at) <= SELF_ACTION_TTL_MS;
}
